import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["input", "button"]
  static values = { text: String }

  initialize() {
    this.buttonTarget.disabled = true
  }

  checkForMatch() {
    if (this.inputTarget.value.toUpperCase() === this.textValue) {
      this.buttonTarget.disabled = false
    } else {
      this.buttonTarget.disabled = true
    }
  }
}
